module.exports = __webpack_public_path__ + "img/dentist-showing-teeth.a368e421.png";